import { Component } from '@angular/core';

@Component({
  selector: 'app-error500',
  templateUrl: './error500.component.html',
  styleUrl: './error500.component.css',
  standalone: false
})
export class Error500Component {

}
